import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=9a40ccbc&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a40ccbc')) {
      api.createRecord('9a40ccbc', component.options)
    } else {
      api.reload('9a40ccbc', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=9a40ccbc&", function () {
      api.rerender('9a40ccbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hWSQS9C6p6bF/JS/videoIframe.vue"
export default component.exports